export default "__VITE_ASSET__Cexc9uG3__"